<script setup lang="ts">
import { RouterView } from 'vue-router';
import BootstrapErrorGate from '@/components/Shared/Gates/BootstrapErrorGate/BootstrapErrorGate.vue';
import { useBootstrapStore } from '@/core/shared/bootstrap/bootstrap.store';
import { useMobileViewModeBootReset } from '@/composables/useMobileViewModeBootReset';
import { usePrivacyMode } from '@/composables/usePrivacyMode';

const bootstrapStore = useBootstrapStore();

useMobileViewModeBootReset();
usePrivacyMode();
</script>

<template>
  <v-app>
    <!-- A failed bootstrap leaves the stores half-initialized, so rendering any
         route would cascade errors. Short-circuit into a reload gate that needs
         no auth or API data. -->
    <BootstrapErrorGate v-if="bootstrapStore.hasBlockingError" />
    <RouterView v-else />
  </v-app>
</template>
